import { useContext, useState } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import tripImage from "../../assets/images/trip_image.jpg";
import Pagination from "../../components/Pagination";
import DeleteConfirmation from "../../components/DeleteConfirmation";
import { Link } from "react-router-dom";

const TripVideos = () => {
  const { t } = useContext(LocaleContext);
  const [isChecked, setIsChecked] = useState(true); // default checked
  const handleChecked = () => {
    setIsChecked(!isChecked);
  };
  return (
    <>
      <section className="section-trip-videos">
        <div className="default-heading">{t("tripVideos")}</div>
        <section className="section-dashboard-cards mb-3">
          <div className="row">
            <div className="col-12 col-md-3">
              <div className="d-card d-card-primary">
                <div className="d-card-header">{t("totalVideos")}</div>
                <div className="d-card-body">
                  <div className="d-card-body-1">
                    <span>7,125.70</span>
                    <span>{t("newThisMonth")}: 3</span>
                  </div>
                  <div className="d-card-body-2">
                    <span>52.0%</span>
                    <i className="fas fa-arrow-circle-up"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="d-card d-card-dark">
                <div className="d-card-header">{t("totalTrips")}</div>
                <div className="d-card-body">
                  <div className="d-card-body-1">
                    <span>7,125.70</span>
                    <span>{t("newThisMonth")}: 3</span>
                  </div>
                  <div className="d-card-body-2">
                    <span>52.0%</span>
                    <i className="fas fa-arrow-circle-up"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="d-card d-card-primary">
                <div className="d-card-header">{t("tripsWithoutVideos")}</div>
                <div className="d-card-body">
                  <div className="d-card-body-1">
                    <span>7,125.70</span>
                    <span>{t("newThisMonth")}: 3</span>
                  </div>
                  <div className="d-card-body-2">
                    <span>52.0%</span>
                    <i className="fas fa-arrow-circle-up"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="d-card d-card-dark">
                <div className="d-card-header">{t("totalRevenue")}</div>
                <div className="d-card-body">
                  <div className="d-card-body-1">
                    <span>7,125.70</span>
                    <span>{t("newThisMonth")}: 3</span>
                  </div>
                  <div className="d-card-body-2">
                    <span>52.0%</span>
                    <i className="fas fa-arrow-circle-up"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section-grid">
          <div className="grid-card">
            <div className="grid-card-header">
              <strong>{t("tripVideosManagement")}</strong>
              <p>{t("viewAndManageTripVideos")}</p>
            </div>
            <div className="grid-card-body">
              <div className="table-header">
                <div className="table-header-icons hidden">
                  <div className="icon-box">
                    <i className="fas fa-file-pdf"></i>
                  </div>
                  <div className="icon-box">
                    <i className="fas fa-file-excel"></i>
                  </div>
                  <div className="icon-box">
                    <i className="fas fa-print"></i>
                  </div>
                </div>
                <div className="table-search">
                  <div className="input-icon input-icon-width">
                    <input
                      type="text"
                      className="form-control input-search"
                      placeholder={t("search")}
                    />
                    <i className="fas fa-search"></i>
                  </div>
                  <div className="grid-btn">
                    <Link to="/trip-video-form">
                      <button className="btn-default my-bg-secondary">
                        {t("addNewVideo")} <i className="fas fa-plus"></i>{" "}
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="table-delete-option mt-3">
                <b>{t("allTrips")}</b>
                <div className="dropdown">
                  <i
                    className="fas fa-filter cursor-pointer"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  />
                  <span></span>
                  <ul className="dropdown-menu">
                    <li>
                      <a className="dropdown-item" href="#">
                        <input type="radio" /> {t("status")}
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        <input type="radio" /> {t("category")}
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        <input type="radio" /> {t("city")}
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        <input type="radio" /> {t("date")}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="my-table">
                <table className="table">
                  <thead>
                    <tr>
                      <th>
                        <input type="checkbox" />
                      </th>
                      <th>{t("code")}</th>
                      <th>{t("video")}</th>
                      <th>{t("address")}</th>
                      <th>{t("category")}</th>
                      <th>{t("status")}</th>
                      <th>{t("date")}</th>
                      <th>{t("actions")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.from({ length: 10 }).map((_, index) => (
                      <tr key={index}>
                        <td>
                          <input type="checkbox" />
                        </td>
                        <td>1</td>
                        <td>
                          <div className="grid-image">
                            <img src={tripImage} alt="image" />
                          </div>
                        </td>
                        <td>الدمام</td>
                        <td>جلسات خارجية</td>

                        <td>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="flexSwitchCheckChecked"
                              checked={isChecked}
                              onChange={handleChecked}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="flexSwitchCheckChecked"
                            ></label>
                          </div>
                        </td>
                        <td>15-01-2026</td>
                        <td>
                          <i
                            class="fas fa-ellipsis-vertical"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          ></i>
                          <ul className="dropdown-menu">
                            <li>
                              <a className="dropdown-item" href="#">
                                <i className="fas fa-edit"></i> {t("edit")}
                              </a>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/trip-video-details/1"
                              >
                                <i className="fas fa-eye"></i> {t("view")}
                              </Link>
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) => e.preventDefault()}
                                data-bs-toggle="modal"
                                data-bs-target="#my-modal"
                              >
                                <i className="fas fa-trash-alt text-danger"></i>{" "}
                                {t("delete")}
                              </a>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="grid-footer">
              <Pagination t={t} />
            </div>
          </div>
        </section>
      </section>
      <DeleteConfirmation t={t} />
    </>
  );
};

export default TripVideos;
